export const SET_SELECTED_STATE = "SET_SELECTED_STATE";
export const SET_STATES = "SET_STATES";
export const SET_STATE_ERROR = "SET_STATE_ERROR";
export const SET_STATES_LOADING = "SET_STATES_LOADING";
